import ClubMemberSegmentBar from './ClubMemberSegmentBar';

export default ClubMemberSegmentBar;
